const colors = {
  primary: '#ED1C24',
  label: '#707070',
  error: '#dc3545',

  googleColor: '#E33E2B',
  facebookColor: '#2462A8',
  appleColor: '#707070',
}

export default colors;
